module.exports = __webpack_public_path__ + "img/news3.87fc6f36.png";